<template>
  <div>
    <label :for="name" class="block text-sm font-medium text-gray-700">
      {{ displayLabel }}
    </label>
    <div class="mt-1">
      <textarea :name="name"
                v-model="value"
                :rows="rows"
                class="shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
                :class="{ '-error': error }"></textarea>
    </div>
    <p v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
  </div>
</template>

<style scoped>
input {
  @apply block w-full pr-10 border-gray-300 text-gray-900 placeholder-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md;
}

input.-error {
  @apply border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500;
}
</style>

<script>
import FormCommon from './form-mixin'
import FormInput from './form-input.vue'

export default {
  extends: FormInput,

  props: {
    rows: {
      type: Number,
      default: 5,
    }
  }
}
</script>
